const tutorialPopUpTranslations = {
  title: "Tutorial",
};

export default tutorialPopUpTranslations;
